import moment from 'moment';
import _isNil from 'lodash/isNil';

const TIME_REGEX = /([0-9]{2}):([0-9]{2})/;

export const datetimeToHours = datetime => {
  const time = datetime.format('HH:mm');
  if (TIME_REGEX.test(time)) {
    const [, hh, mm] = time.match(TIME_REGEX);
    const hours = Number(hh) + Number(mm) / 60;

    return hours;
  }

  return null;
};

export const hoursToDatetime = hours => {
  if (_isNil(hours)) return null;

  const hh = Math.floor(hours);
  const mm = Math.round((hours - Math.floor(hours)) * 60);

  return moment(`${hh}:${mm}`, 'HH:mm');
};
